import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

export type SocialPlatform = 'linkedin' | 'facebook' | 'twitter' | 'instagram'

export type ResolveLinkedinProfilePayload = {
  fullName: string
  avatarUrl?: string
  bio?: string
  platform?: SocialPlatform
  handle?: string
  profileUrl?: string
  contacts?: {
    email?: string | null
    phone?: string | null
    website?: string | null
    facebook?: string | null
    instagram?: string | null
    twitter?: string | null
    linkedin?: string | null
  }
}

export type ResolveLinkedinProfileResponse = {
  id: string
  kind: 'profile' | 'ghost'
  created?: boolean
  updated?: boolean
}

const resolveLinkedinProfile = async (
  payload: ResolveLinkedinProfilePayload,
): Promise<ResolveLinkedinProfileResponse> => {
  const { data } = await api.post<ResolveLinkedinProfileResponse>(
    '/ghost-profiles/resolve',
    payload,
  )
  return data
}

export const useResolveLinkedinProfile = () => {
  return useMutation<ResolveLinkedinProfileResponse, Error, ResolveLinkedinProfilePayload>({
    mutationFn: resolveLinkedinProfile,
  })
}
